export const TranscriptIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={className}
         dangerouslySetInnerHTML={{
            __html: `
       <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        >
        <g clip-path="url(#clip0_207_327)">
            <path
                d="M15.4167 5C12.89 5 10.8333 7.05583 10.8333 9.58333C10.8333 10.69 11.2283 11.7067 11.8842 12.5H8.11667C8.7725 11.7067 9.16667 10.69 9.16667 9.58333C9.16667 7.05583 7.11083 5 4.58333 5C2.05583 5 0 7.05583 0 9.58333C0 12.1108 2.05583 14.1667 4.58333 14.1667H15.4167C17.9433 14.1667 20 12.1108 20 9.58333C20 7.05583 17.9433 5 15.4167 5ZM1.66667 9.58333C1.66667 7.975 2.975 6.66667 4.58333 6.66667C6.19167 6.66667 7.5 7.975 7.5 9.58333C7.5 11.1917 6.19167 12.5 4.58333 12.5C2.975 12.5 1.66667 11.1917 1.66667 9.58333ZM15.4167 12.5C13.8083 12.5 12.5 11.1917 12.5 9.58333C12.5 7.975 13.8083 6.66667 15.4167 6.66667C17.025 6.66667 18.3333 7.975 18.3333 9.58333C18.3333 11.1917 17.025 12.5 15.4167 12.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_207_327">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
